// src/services/textService.js
import defaultTexts from '@/assets/texts/defaultTexts.json'

export default {
  texts: {...defaultTexts},
  
  /**
   * دریافت متن با پشتیبانی از کلیدهای تو در تو و جایگزینی پارامترها
   * @param {string} key - کلید به فرم 'parent.child.subchild'
   * @param {object} params - پارامترهای جایگزین شونده در متن
   */
  getText(key, params = {}) {
    const keys = key.split('.');
    let text = keys.reduce((obj, k) => (obj || {})[k], this.texts) || key;
    
    if (typeof text !== 'string') {
      console.warn(`Text key '${key}' is not a string!`, text);
      return key;
    }
    
    // جایگزینی پارامترهای داینامیک
    Object.keys(params).forEach(param => {
      text = text.replace(new RegExp(`{{\\s*${param}\\s*}}`, 'g'), params[param]);
    });
    
    return text;
  },
  
  /**
   * آپدیت متون با پشتیبانی از ساختار درختی
   * @param {object} data - داده‌های جدید (می‌تواند تودرتو باشد)
   * @param {boolean} deepMerge - آیا ادغام عمیق انجام شود؟
   */
  async updateTexts(data, deepMerge = true) {
    if (!data) return false;
    
    if (deepMerge) {
      // ادغام عمیق (Deep Merge)
      this.mergeDeep(this.texts, data);
    } else {
      // ادغام سطحی
      this.texts = {...this.texts, ...data};
    }
    return true;
  },
  
  /**
   * تابع کمکی برای ادغام عمیق اشیا
   */
  mergeDeep(target, source) {
    Object.keys(source).forEach(key => {
      if (source[key] instanceof Object && key in target) {
        this.mergeDeep(target[key], source[key]);
      } else {
        target[key] = source[key];
      }
    });
  }
};